import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]

  connect() {
    // Fix pagination links to target the documents frame
    this.adjustPaginationLinks()
    
    // Listen for any DOM changes within the frame to update newly added links
    this.observer = new MutationObserver(mutations => {
      this.adjustPaginationLinks()
    })
    
    this.observer.observe(this.element, { 
      childList: true, 
      subtree: true 
    })
  }
  
  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
  
  adjustPaginationLinks() {
    // Find all pagination links
    const paginationLinks = this.element.querySelectorAll('.pagination a')
    
    // Update each link to target our frame
    paginationLinks.forEach(link => {
      link.setAttribute('data-turbo-frame', 'documents')
    })
  }
}